export default {
  state: () => ({
    carouselList: null,
    liveList: null,
  }),
  mutations: {

  },
  actions: {

  },
  getter: {

  }
};